'use client';

import Header from "@/app/components/Header";
import Navigation from "@/app/components/Navigation";
import { useSession } from "next-auth/react";

export default function DashboardLayout({ children }: { children: React.ReactNode }) {
    const { data: session, status } = useSession();

    if (status === 'loading') {
      return null;
    }

    if (!session) {
      return null;
    }
    return (
        <div className="min-h-screen bg-gray-100 p-6">
            <Header />
            <div className="flex gap-6">
                <Navigation />
                <div className="w-3/4 bg-white shadow-lg rounded-lg p-4 border-t-4 border-gray-300">
                    <section>{children}</section>
                </div>
            </div>
        </div>
    );
}